import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { useDimensions } from '@telavita-core/react-design-kit'

import { UserData } from 'models/Auth'

import { CreditsPanelWrapper } from './components/CreditsPanelWrapper'
import { ScheduleContainerWrapper } from './components/ScheduleContainerWrapper'
import { ScheduleIntro } from './components/ScheduleIntro'

import { useGetProfessionalProfile } from './hooks/useGetProfessionalProfile'
import { useOctadeskChat } from 'hooks'
import { useScrollToTop } from 'hooks/useScrollToTop'

import * as S from './styles'

type LocationState = {
  next: string
  showText: boolean
}

export function NpsSchedule() {
  useScrollToTop()
  useOctadeskChat({ hide: true })
  
  const location = useLocation<LocationState>()
  const professionalSlug = location.state?.next
  const patientFirstName = useSelector((state: UserData) => state.auth?.userData?.person_general?.first_name)
  
  const { isMobile } = useDimensions()
  const { 
    professionalProfile, 
    professionalProfileLoading 
  } = useGetProfessionalProfile(professionalSlug)

  return (
    <>
      <S.Container isMobile={isMobile}>
        <ScheduleIntro
          showThanksText={location.state?.showText}
          patientFirstName={patientFirstName}
          professionalInfo={professionalProfile}
          professionalProfileLoading={professionalProfileLoading}
        />
        <ScheduleContainerWrapper
          professional={professionalProfile}
        />
      </S.Container>
      <CreditsPanelWrapper />
    </>
  )
}